export default __webpack_public_path__ + "static/media/logo_original-recreation.40befe85.png";